<app-header>
  <jbm-view-title
    [caption]="'financial.price-agreements'|translate"
    [itemcount]="queryHttpHelper.paginationProps.itemCount"
    [parentLinkCaption]="'menu.settings'|translate"
    [parentLinkSlug]="'settings'">
  </jbm-view-title>
  <div class="toolbar float-end">
    <jbm-spinner [loading]="loading"></jbm-spinner>
    <div class="toolbar-spacer-1"></div>
    <jbm-pagination
      [itemCount]="queryHttpHelper.paginationProps.itemCount"
      [pageSize]="queryHttpHelper.paginationProps.pageSize"
      [page]="queryHttpHelper.paginationProps.page"
      (pageClick)="pageChange($event)">
    </jbm-pagination>
    <jbm-searchbox
      [id]="'price-agreements-search'"
      [visible]="searchboxVisible && !filtersVisible"
      [search]="search"
      (searchChange)="searchChange($event)">
    </jbm-searchbox>
    <div class="toolbar-spacer-1"></div>
    <jbm-filter-toggle [showFilter]="filtersVisible" (onToggle)="toggleFilters()"></jbm-filter-toggle>
  </div>
</app-header>

<section class="module">
  <jbm-table
    [id]="'price-agreements'"
    [classname]="'price-agreements padding'"
    [data]="items"
    [filterable]="true"
    [showFilters]="filtersVisible"
    [sortable]="true"
    [sortColumn]="queryHttpHelper.sortProps.name"
    [sortDirection]="queryHttpHelper.sortProps.direction"
    [hoverable]="true"
    [rowSelectable]="userRights.AllowUpdate"
    [columnDefs]="columnDefs"
    (sortChange)="sortChange($event)"
    (filterChange)="filterChange($event)"
    (rowSelect)="rowSelect($event)">
  </jbm-table>
  <jbm-empty-view [emptyView]="!loading && queryHttpHelper.paginationProps.itemCount===0"></jbm-empty-view>
</section>

<ng-template #actionsTemplate let-data="data">
  <jbm-edit-button
    *ngIf="userRights.AllowUpdate"
    (onClick)="rowSelect(data)">
  </jbm-edit-button>
</ng-template>

<jbm-modal [id]="'price-agreement'" [className]="'price-agreement'"></jbm-modal>
<ng-template #priceAgreementModal let-modal>
  <price-agreement
    [agreement]="priceAgreement"
    (onSave)="priceAgreementSaved()"
    (onCancel)="priceAgreementCancelled()">
  </price-agreement>
</ng-template>
